export default "__VITE_ASSET__oqfGAV1f__"